import { render, staticRenderFns } from "./HeadCountSegDepComponent.vue?vue&type=template&id=ff672e5e&"
import script from "./HeadCountSegDepComponent.vue?vue&type=script&lang=js&"
export * from "./HeadCountSegDepComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports